// This file is now deprecated. Use the context-based approach instead.
// Import from the context for better caching and performance.
import { useOrganizationOptions } from '../context/organization-options-context'

// Export the main hook
export const useClaimedByOptions = useOrganizationOptions

// Re-export for backward compatibility
export const useMuckGutClaimedByOptions = useOrganizationOptions
